<template>
  <a-row type="flex" class="region-setup-box">
    <a-col flex="240px" class="region-setup divide">
      <a-steps direction="vertical" :current="current_step">
        <a-step v-for="(step, index) in steps" :key="index" :title="step.title">
          <template #description>
            <span v-show="step.waitting">{{ step.desc[0] }}</span>
            <div v-show="step.configuring"><span>{{ step.desc[1] }}</span><a-button type="link" v-if="step.go" @click="step.go">前往配置</a-button></div>
            <span v-show="step.configured">{{ step.desc[2] }}</span>
          </template>
        </a-step>
      </a-steps>
    </a-col>
    <a-col flex="auto" class="region-setup">
      <region-setup-summary :cloudregion="cloudregion" :cloudaccount="cloudaccount" />
    </a-col>
  </a-row>
</template>

<script>
import * as R from 'ramda'
import RegionSetupSummary from './RegionSetupSummary'

export default {
  name: 'RegionSetup',
  components: { RegionSetupSummary },
  props: {
    cloudaccount: {
      type: Object,
      required: true,
    },
    cloudregion: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      current: 0,
    }
  },
  computed: {
    showSetupGuide () {
      return !!R.path(['setup', 'can_setup'], this.cloudregion)
    },
    current_step () {
      const s = R.path(['setup', 'status'], this.cloudregion)
      switch (s) {
        case 'setup_vpc':
          return 1
        case 'setup_network':
          return 2
        case 'configured':
          return 3
      }
      return 0
    },
    steps () {
      const s = this.current_step
      return [
        { title: '可用区', waitting: false, configuring: s === 0, configured: s > 0, go: undefined, desc: ['', '状态异常或暂不配置', '状态正常'] },
        { title: 'VPC', waitting: s < 1, configuring: s === 1, configured: s > 1, go: this.goVpcPage, desc: ['待配置', 'VPC待配置', '已配置'] },
        { title: 'IP子网', waitting: s < 2, configuring: s === 2, configured: s > 2, go: this.goNetworkPage, desc: ['待配置', '子网待配置', '已配置'] },
        { title: '结果', waitting: s < 3, configuring: false, configured: s === 3, go: undefined, desc: ['待配置完成', '', '已完成初始配置'] },
      ]
    },
  },
  methods: {
    go (url) {
      this.$router.push(url).then(() => { window.location.reload() })
    },
    goVpcPage () {
      this.go('/vpc/create?type=public')
    },
    goNetworkPage () {
      this.go('/network/create?type=public')
    },
  },
}
</script>

<style lang="less" scoped>
.region-setup-box {
  width: inherit;
  height: 100%;

  .divide {
    border-right: 1px solid #e8e8e8;
  }

  .region-setup {
    overflow: auto;
    padding: 12px;
  }
}
</style>
